import React, { Component } from "react";
import styles from "./Popup.module.scss";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import { withRouter } from "react-router-dom";
import Button from "../UI/Button/Button";

var classNames = require("classnames");

class ViewByModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
      selectedOption: this.props.selectedOption,
    };
  }

  componentWillUnmount() {
    this.setState({ showPopup: false });
  }

  componentDidUpdate() {
    if (!this.props.viewByOptions.includes(this.state.selectedOption)) {
      this.setState({ selectedOption: "Weekly" })
    }
  }

  render() {
    if (this.props.isVisible) {
      document.body.classList.add("popup-mode");
    } else {
      document.body.classList.remove("popup-mode");
    }

    let CloseAlertControls = classNames(
      "tileBg2 " + styles.closeAlertControls,
      this.props.className,
      {
        [styles.visible]: this.props.isVisible,
      },
      styles.viewbyModalClass
    );

    let DarkMask = classNames(styles.darkMask, this.props.className, {
      [styles.visible]: this.props.isVisible,
    });

    return (
      <Wrapper>
        <div>
          <div className={CloseAlertControls}>
            <div className={styles.content}>
              <div className={styles.spanButtons + " " + styles.headingRow}>
                <span>{"View by"}</span>
                <button
                  className="closeAlertControls__btn -close"
                  onClick={this.props.onClose}
                >
                </button>
              </div>
              <form>
                <fieldset>
                  <div>
                    {this.props.viewByOptions.map((e, index) => {
                      return (<div key={index} className={styles.listItem}>
                        <label htmlFor={e}>{e}</label>
                        <input
                          type="radio"
                          name="viewByOptions"
                          id={e}
                          value={e}
                          checked={this.state.selectedOption === e}
                          onChange={(change) => this.setState({ selectedOption: change.target.value })}
                        ></input>
                      </div>)
                    })}
                  </div>
                </fieldset>
              </form>
              <ul>
              </ul>
              <div className={styles.footerButtonContainer}>
                <Button
                  label="Back"
                  buttonClick={this.props.backButton}
                  content="Back"
                  variant="btn_secondary"
                  styles="footerButton"
                ></Button>
                <Button
                  label="Apply"
                  buttonClick={() => this.props.applyButton(this.state.selectedOption)}
                  content="Apply"
                  variant="btn_secondary"
                  styles="footerButton saveBtnStyle"
                ></Button>
              </div>
            </div>
          </div>
          <div className={DarkMask} />
        </div>
      </Wrapper>
    );
  }
}

export default withRouter(ViewByModal);
